/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserFacilityAccessRequest
 */
export interface UpdateUserFacilityAccessRequest {
    /**
     * 
     */
    facility_ids: Array<string>;
    /**
     * 
     */
    action: UpdateUserFacilityAccessRequestActionEnum;
}


/**
 * @export
 */
export const UpdateUserFacilityAccessRequestActionEnum = {
    Grant: 'Grant',
    Revoke: 'Revoke',
} as const;
export type UpdateUserFacilityAccessRequestActionEnum = typeof UpdateUserFacilityAccessRequestActionEnum[keyof typeof UpdateUserFacilityAccessRequestActionEnum];


/**
 * Check if a given object implements the UpdateUserFacilityAccessRequest interface.
 */
export function instanceOfUpdateUserFacilityAccessRequest(value: object): value is UpdateUserFacilityAccessRequest {
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function UpdateUserFacilityAccessRequestFromJSON(json: any): UpdateUserFacilityAccessRequest {
    return UpdateUserFacilityAccessRequestFromJSONTyped(json, false);
}

export function UpdateUserFacilityAccessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserFacilityAccessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_ids': json['facility_ids'],
        'action': json['action'],
    };
}

export function UpdateUserFacilityAccessRequestToJSON(json: any): UpdateUserFacilityAccessRequest {
    return UpdateUserFacilityAccessRequestToJSONTyped(json, false);
}

export function UpdateUserFacilityAccessRequestToJSONTyped(value?: UpdateUserFacilityAccessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_ids': value['facility_ids'],
        'action': value['action'],
    };
}

